var set = require('regenerate')(0x965, 0x1940);

set.addRange(0x1900, 0x191E).addRange(0x1920, 0x192B).addRange(0x1930, 0x193B).addRange(0x1944, 0x194F);
module.exports = set;